import { getRiskText } from '../../../questionResponseIssue/riskCategory';
import { ISSUE_RISK_ID } from '../../../../types/enums';

export const getRiskOptions = () => [
  { value: ISSUE_RISK_ID.high, text: getRiskText(ISSUE_RISK_ID.high) },
  { value: ISSUE_RISK_ID.medium, text: getRiskText(ISSUE_RISK_ID.medium) },
  { value: ISSUE_RISK_ID.low, text: getRiskText(ISSUE_RISK_ID.low) },
  { value: ISSUE_RISK_ID.none, text: getRiskText(ISSUE_RISK_ID.none) },
];
